import { Buffer } from 'buffer';
import process from 'process';

// Polyfill Buffer for Webpack 5 (required by react-pdf)
global.Buffer = Buffer;
window.Buffer = Buffer;
global.process = process;
window.process = process;
